import PropTypes from 'prop-types';
import { resolveByCountry } from '@codex/helpers';
import styled from 'styled-components';
import { OnOffSwitch } from '@codex/basics';
import { colors } from '@codex/themes';


const ShowDifferencesOnOffSwitch = styled(OnOffSwitch)`
  margin-top: 10px;
  div {
    border: 1px solid #ccc;
    height: 32px;
  }
`;

const Separator = styled.div`
  border-bottom: 1px solid  ${colors.shades[5]};
`;

export default function ShowDifferencesTableCell({ active, onShowDifferencesOnOffSwitchClick }) {

  return (
    <>
      {/* TODO: Add to translations */}
      <p>Here are the items you`ve chosen to compare. </p>
      <p>
        For more help deciding, why not view our
        {' '}
        <a
          href={`https://www.currys.${resolveByCountry('co.uk/gbuk', 'ie/ieen')}/buying-guides-1022-commercial.html`}
          target={'_blank'} // eslint-disable-line react/jsx-no-target-blank
          rel={'noopener noreferrer'}
        >
          {/* TODO: Add to translations */}
          Buying Guide
        </a>
      </p>
      <Separator />
      <ShowDifferencesOnOffSwitch
        label={active ? 'Yes' : 'No'}
        active={active}
        onClick={(e) => {
          e.preventDefault();
          onShowDifferencesOnOffSwitchClick();

        }}
      >
        Show Differences
      </ShowDifferencesOnOffSwitch>
    </>
  );
}

ShowDifferencesTableCell.propTypes = {
  active: PropTypes.bool.isRequired,
  onShowDifferencesOnOffSwitchClick: PropTypes.func.isRequired
};
